<template>
  <div class="wd-100p ht-100p">
    <Header></Header>
    <div class="wd-100p ht-100p cr-hei">
      <div class="wd-100p pos-r">
        <div class="wd-100p ht-100vh ov-h bg-white">
          <div class="ht-100p pos-r ov-h">
            <div class="wd-100p ht-100p pos-r">
              <iframe :src="virtualLink" class="wd-100p ht-100p" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  components: {
    Header, Footer,
  },
  data() {
    return {
    };
  },
  methods: {
    clickref(ref) {
      this.pushr(ref);
    },
  },
  created() {
  },
  computed: {
    mob() {
      return this.$store.state.mob;
    },
    virtualLink() {
      return this.$store.state.virtualLink;
    }
  },
  watch: {
  },
  beforeDestroy() { },
};
</script>